export default "__VITE_ASSET__CbjuOMw___"